module.exports = __webpack_public_path__ + "img/ry1.f5378e29.svg";